module.exports = __webpack_public_path__ + "static/mobile-map-80cbce061065df0000ccfed6f2d207f0.png";